import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: '256-bit encryption'
    },
    {
      icon: 'Lock',
      title: 'Secure Login',
      description: 'Protected authentication'
    },
    {
      icon: 'CheckCircle',
      title: 'Verified Platform',
      description: 'Trusted by publishers'
    }
  ];

  return (
    <div className="w-full max-w-md mx-auto mt-8">
      <div className="bg-muted/50 rounded-lg p-6">
        <h3 className="text-sm font-medium text-foreground mb-4 text-center">
          Your data is protected
        </h3>
        
        <div className="grid grid-cols-3 gap-4">
          {securityFeatures?.map((feature, index) => (
            <div key={index} className="text-center">
              <div className="flex items-center justify-center w-10 h-10 bg-success/10 rounded-full mx-auto mb-2">
                <Icon name={feature?.icon} size={20} className="text-success" />
              </div>
              <h4 className="text-xs font-medium text-foreground mb-1">
                {feature?.title}
              </h4>
              <p className="text-xs text-muted-foreground">
                {feature?.description}
              </p>
            </div>
          ))}
        </div>
        
        <div className="mt-4 pt-4 border-t border-border">
          <p className="text-xs text-muted-foreground text-center">
            Trusted by 500+ publishing professionals worldwide
          </p>
        </div>
      </div>
    </div>
  );
};

export default SecurityBadges;